module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-1280x160-912dc46440ba15a0f29897145729ba44.webp";